import { render, staticRenderFns } from "./CommunityFaqReply.vue?vue&type=template&id=cc2a9664"
import script from "./CommunityFaqReply.vue?vue&type=script&lang=js"
export * from "./CommunityFaqReply.vue?vue&type=script&lang=js"
import style0 from "./CommunityFaqReply.vue?vue&type=style&index=0&id=cc2a9664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports